var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ClaimForm',{attrs:{"promotionId":_vm.$route.params.id,"claimId":_vm.$route.query.claimId,"public":false,"enableOcr":true,"showExampleImages":true,"strings":{ mask: [] },"reminders":[
    {
      text:
        'For all Sony product, except Xperia, the middle-seven digits should be entered (e.g. S01-4036705-B -> 4036705)'
    },
    { text: 'For Xperia product, the full IMEI is required (e.g., 35242794-019573-7)' }
  ]},on:{"stepChange":function($event){return _vm.$vuetify.goTo(0)},"onCancel":_vm.onCancel},scopedSlots:_vm._u([{key:"example-images",fn:function(){return [_c('v-img',{attrs:{"src":require("@/assets/all-sony-product-except-xperia.png")}}),_c('v-img',{attrs:{"src":require("@/assets/for-xperia-only.png")}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }